import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { BehaviorSubject, Subject, debounceTime, distinctUntilChanged, tap } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { GigsumoService } from 'src/app/services/gigsumoService';
import { SearchData } from 'src/app/services/searchData';
import { UtilService } from 'src/app/services/util.service';
import { UserCardConfig } from 'src/app/types/UserCardConfig';
import { CommonSkeletonComponent } from '../../../skeleton/common-skeleton/common-skeleton.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { FilterPipe } from '../../../pipe/SearchFilter/filter.pipe';
import { UserCardComponent } from '../../../components/cards/user-card/user-card.component';
import { NodataFoundComponent } from '../../../widget/nodata-found/nodata-found.component';
import { WidgetModule } from '../../../widget/widget.module';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: 'app-connection',
  standalone: true,
  imports: [BsDropdownModule, CommonModule, ReactiveFormsModule, FormsModule,
CommonSkeletonComponent, InfiniteScrollModule, FilterPipe, UserCardComponent, NodataFoundComponent, WidgetModule,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './connection.component.html',
  styleUrls: ['./connection.component.scss']
})
export class ConnectionComponent implements OnInit {

  connectionData: any = "CONNECTED"
  connectionlistuserdata: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

  // recivedListUserData:any;
  //InvitationListUserData:any;
  listConnection: any;
  noDatafound: Array<string>;
  showNoDatafound: boolean = false;
  @ViewChild('landingside1') menuElement: ElementRef;
  landingsidesticky1: boolean = false;
  landingsidesticky2: boolean = false;
  elementPosition: any;
  allData: boolean = true;
  stopScroll : boolean = false;
  recivedData: boolean = false;
  InvitationData: boolean = false;
  prevAfterkey = null;
  btnnameshow: any;
  connectallshow: boolean = false;
  allConnectallshow: boolean = false;
  Requestshow: boolean = false
  Invitationsshow: boolean = false;
  connect: boolean = true;
  allConnect: boolean = true;
  requestsent: boolean = false;
  requestrecived: boolean = false;
  isEnabled: boolean = false;
  userCardConfig: UserCardConfig[] = []
  Search = "";
  loadAPIcall:boolean=false
  status = "ALL";
  filterame;
  count: number = 0;
  searchKey
  searchSubject = new Subject<string>();

  constructor(
    private util: UtilService,
    private api: ApiService,
    private gigsumoService: GigsumoService,
    private searchData : SearchData) { }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.apicall(this.status);


    this.searchSubject.pipe(
      debounceTime(500),
      distinctUntilChanged(),
    )
      .subscribe(
        res => {
          this.util.startLoader();
          this.updateSearch();
        }
      )

  }
  @HostListener('window:scroll')
  handleScroll() {
    const windowScroll = window.pageYOffset;
    if (windowScroll >= 24) {
      this.landingsidesticky1 = true;
      this.landingsidesticky2 = true;
    } else {
      this.landingsidesticky1 = false;
      this.landingsidesticky2 = false;
    }
  }

  onsearch(val) {
    this.Search = val;
    this.apicall(this.status);
  }

  searchContent:string="";
  obj: any = {
    limit: 12,
    userId: localStorage.getItem('userId'),
    searchAfterKey: null,
    status:this.status,
    searchContent:this.searchContent
  }


  keyupdata(value : string) {
      this.searchSubject.next(value);
  }

  updateSearch() {
    this.obj.searchContent = this.searchContent.trim() !== "" ? this.searchContent.trim() : null;
    this.obj.searchAfterKey = null;
    this.count = 0;
    this.stopScroll = false;
    this.connectionlistuserdata.next([]);
    this.apicall(this.status);
    this.util.stopLoader();
  }

  onScrollDown() {

    if(JSON.stringify(this.obj.searchAfterKey)!=JSON.stringify(this.prevAfterkey)){
      this.obj.searchAfterKey = (this.prevAfterkey && this.prevAfterkey.length === 0) ? null : this.prevAfterkey;
        this.apicall(this.status);
    }


  }
  filterstatus(filter, status?: string){
    this.obj.searchAfterKey=null;
    this.obj.searchContent="";
    this.searchContent = '';
    this.count=0
    this.stopScroll=false
    this.connectionlistuserdata.next([]);
    this.apicall(filter);
  }

  apicall(filter, status?: string) {

    if(this.stopScroll){
      return
    }

    this.loadAPIcall = true;
    let noData: Array<string> = [];
    this.obj.status = filter;
    this.status = filter;
    if (this.status === 'CONNECTED') {
      noData = this.searchContent !== "" ? ['No data available!'] : ['No Active Connection'];
      this.btnnameshow = 'Active Connections'
      this.connectallshow = false;
      this.Requestshow = true;
      this.Invitationsshow = true;
      this.connect = true;
      this.requestsent = false;
      this.requestrecived = false;
      this.allConnect = false;
      this.allConnectallshow = false;
    } else if (this.status === 'REQUEST_RECEIVED') {
      noData = this.searchContent !== "" ? ['No data available!'] : ['No Connection Requests Received'];
      this.btnnameshow = 'Requests Received'
      this.connectallshow = true;
      this.Requestshow = false;
      this.Invitationsshow = true;
      this.connect = false;
      this.requestsent = false;

      this.requestrecived = true;
      this.allConnect = false;
      this.allConnectallshow = false;
    } else if (this.status === 'REQUEST_SENT') {
      noData = this.searchContent !== "" ? ['No data available!'] : ['No Connection Requests Sent'];
      this.btnnameshow = 'Requests Sent'
      this.connectallshow = true;
      this.Requestshow = true;
      this.Invitationsshow = false;
      this.allConnect = false;
      this.connect = false;
      this.requestsent = true;

      this.requestrecived = false;
      this.allConnectallshow = false;
    } else if (this.status === 'ALL'&&!this.searchContent) {
      noData = ['b Please do one of the below, for Connections to be listed in the page',
        '1 . Update your profile with your company business email ID.',
        '2 . Complete your current work experience section in your profile.',
        '3 . Search for your colleagues by name.',
        '4 . click "Connect" on user profile.']
      this.btnnameshow = 'All'
      this.allConnect = true;
      this.connect = false;
      this.requestsent = false;
      this.requestrecived = false;

      this.allConnectallshow = true;
    }else if( this.searchContent !== ""){
      noData =  ['No data available!']
    }

    this.isEnabled = true;
    this.util.startLoader();
    this.api.create("user/connection/info", this.obj).subscribe({
      next: (res) => {
      this.util.stopLoader();
          this.loadAPIcall = false;
          this.isEnabled = false;

          let data = res.data.response;

          data.forEach(element => {
            element.userName = element.firstName + " " + element.lastName;
            if (filter === "CONNECTED") {
              element.connectionStatus = "CONNECTED";
              element.page = "connectionList";
            } else if (filter === "REQUEST_SENT") {
              element.page = "connectionList";
              element.connectionStatus = "REQUEST_SENT";
            } else if (filter === "REQUEST_RECEIVED") {
              element.page = "connectionList";
              element.connectionStatus = "REQUEST_PENDING";
            } else if (filter === "ALL") {
              if (element.connectionStatus === "CONNECTED") {
                element.page = "connectionList";
                element.connectionStatus = "CONNECTED";
              } else if (element.connectionStatus === "REQUEST_SENT") {
                element.page = "connectionList";
                element.connectionStatus = "REQUEST_SENT";
              } else if (element.connectionStatus === "REQUEST_PENDING") {
                element.page = "connectionList";
                element.connectionStatus = "REQUEST_PENDING";
              }
            }
          });

          if (data != null) {
            const resData = data;
            const afterKey = res.data && res.data.searchAfterKey;

            if (resData) {

              if (JSON.stringify(this.prevAfterkey) === JSON.stringify(afterKey) || resData.length === 0) {
                this.stopScroll = true;
              }
              this.prevAfterkey = afterKey;
              const combined = this.gigsumoService.removeDuplicatesKey([...this.connectionlistuserdata.getValue() , ...resData] ,  'userId');
              this.connectionlistuserdata.next(combined);


              if (res.data.total!=undefined) {
                this.count = res.data.total;
              }


              if (this.connectionlistuserdata.getValue().length == 0) {
                this.showNoDatafound = true;
                this.noDatafound = noData;
              } else {
                this.showNoDatafound = false;
              }

            }

            if (status === "ACCEPTCONNECT") {
              this.searchData.setContactCount(1);
            }
            else if (status === "REMOVE_CONNECTION") {
              this.searchData.setContactCount(-1);
            }

          }



      },
      error: (err) => {
          this.util.stopLoader();
      },
    });
  }

  dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      if (sortOrder == -1) {
        return b[property].localeCompare(a[property]);
      } else {
        return a[property].localeCompare(b[property]);
      }
    }
  }



  recivedConnection() {
    let recived = " REQUEST_RECEIVED "
    let datas: any = {};
    datas.status = recived;
    datas.userId = localStorage.getItem('userId');
    this.isEnabled=true;
    this.api.create("user/connection/info", datas).subscribe(res => {
      this.isEnabled=false;
      res.data.response.forEach(element => {
        element.userName = element.firstName + " " + element.lastName;
      });

      this.connectionlistuserdata = res.data.response;
      this.allData = false;
      this.recivedData = true;
      this.InvitationData = false;
    });
  }

  REQUEST_SENT() {
    let Invitation = " REQUEST_SENT"
    let datas: any = {};
    datas.status = Invitation;
    datas.userId = localStorage.getItem('userId');
    this.isEnabled=true;
    this.api.create("user/connection/info", datas).subscribe(res => {
      this.isEnabled=false;
      res.data.response.forEach(element => {
        element.userName = element.firstName + " " + element.lastName;
      });
      this.connectionlistuserdata = res.data.response;
      this.allData = false;
      this.recivedData = false;
      this.InvitationData = true;
    });
  }

  ngAfterViewInit() {
    window.scrollTo(0, 0);

  }


  incomingStatus : string = "";

  handleUserCardEvent(data: any): void {
    const currentValue=[]= this.connectionlistuserdata.getValue();
    let filteredValue:any = currentValue;
    if (data.event !== undefined && data.event !== null && data.event !== 'ACCEPTCONNECT') {
      filteredValue = currentValue.filter(element => element.userId !== data.data.userId);
    } else if (data.event === 'ACCEPTCONNECT' && this.status === 'REQUEST_RECEIVED') {
      filteredValue = currentValue.filter(element => element.userId !== data.data.userId);
    } else if (data.event === 'REJECTEDCONNECT') {
      filteredValue = currentValue.filter(element => element.userId !== data.data.userId);
    }
    this.connectionlistuserdata.next(filteredValue);

    if (filteredValue.length === 0) {
      this.showNoDatafound = true;
      this.noDatafound = ['No data available!'];
    } else {
      this.showNoDatafound = false;
    }

    if (data.event === 'ACCEPTCONNECT') {
       this.searchData.setContactCount(1);
    } else if (data.event === "REMOVE_CONNECTION") {
      this.count = this.count - 1;
      this.searchData.setContactCount(-1);
    }
    else if (data.event === "REMOVE_CONNECTION") {
      this.count = this.count - 1;
      this.searchData.setContactCount(-1);
    }else if (data.event === "CANCEL_CONNECT_REQUEST") {
      this.count = this.count - 1;
     }else if (data.event === "REJECTEDCONNECT") {
      this.count = this.count - 1;
     }


      // this.stopScroll=false;
      // this.obj.searchAfterKey = null;
      // this.prevAfterkey = null;
      // this.connectionlistuserdata.next([]);
      // this.apicall(this.status, data.event);
  }

}


